import InativarModal from './InativarModal';

export default InativarModal;